import React from 'react'

import { cn } from '@/legacy-src/lib/utils'
import { getCountryCodeFromLanguage, getLocalisedLanguageName } from '@/legacy-src/utilities/i18n'

type Props = { languageCode: string; className?: string }

const Flag: React.FC<Props> = ({ languageCode, className }) => {
  return (
    <div
      className={cn(
        'relative mr-2 h-5 w-5 overflow-hidden rounded-full border-2 border-solid border-sand-500',
        className,
      )}
      title={getLocalisedLanguageName(languageCode)}
    >
      <div
        className={cn(
          'fi fis absolute left-0 top-0 !h-[16px] !w-[16px]',
          `fi-${getCountryCodeFromLanguage(languageCode).toLowerCase()}`,
        )}
      />
    </div>
  )
}

export default Flag
